import TSService from './service-connector';



let service = new TSService({url: process.env.REACT_APP_WS_URL});
export default service;